import Vue from 'vue'
import { Popover, Tag } from 'ant-design-vue'
import _ from 'lodash'

Vue.use(Popover)
Vue.use(Tag)

export default Vue.extend({
  template: `
        <div>
          <div v-if="params.colDef['cellRendererParams'].name === 'takeoffGrouping'">
            <div v-if="list.length > 1" style="margin-top: -3px;">
              <span v-for="(type, index) in list" :key="index">
                <a-tag color="#71283e" v-if="index < 1" style="margin-top: 4px">
                  {{ type.name ? type.name : type.takeoffGrouping }}
                </a-tag>
              </span>
              <a-popover title="Takeoff Groupings" trigger="hover">
                <template slot="content">
                  <div style="max-height: 300px; overflow-y: auto;">
                    <div class="pb-1" v-for="(type, j) in list" :key="j">
                      <a-tag color="#71283e">{{ type.name ? type.name : type.takeoffGrouping }}</a-tag>
                    </div>
                  </div>
                </template>
                <a-tag color="transparent" class="more-tag">
                  + {{ list.length - 1 }} More
                </a-tag>
              </a-popover>
            </div>
            <div v-else style="margin-top: -3px;">
              <a-tag v-for="(type, i) in list" :key="i" color="#71283e" style="margin-top: 4px">
              {{ type.name ? type.name : type.takeoffGrouping }}
              </a-tag>
            </div>
          </div>
          <div v-if="name=== 'template' || name === 'tenantBank'">
            <div v-if="list.length > 2" style="margin-top: -3px;">
              <span v-for="(type, index) in list" :key="index">
                <a-tag color="#71283e" v-if="index < 1" style="margin-top: 4px">
                  {{ type }}
                </a-tag>
              </span>
              <a-popover :title="params.colDef['cellRendererParams'].type" trigger="hover">
                <template slot="content">
                  <div style="max-height: 300px; overflow-y: auto;">
                    <div class="pb-1" v-for="(type, i) in list" :key="i">
                      <a-tag color="#71283e">{{ type }}</a-tag>
                    </div>
                  </div>
                </template>
                <a-tag color="transparent" class="more-tag">
                  + {{ list.length - 1 }} More
                </a-tag>
              </a-popover>
            </div>
            <div v-else style="margin-top: -3px;">
              <a-tag v-for="(type, i) in list" :key="i" color="#71283e" style="margin-top: 4px">
                {{ type }}
              </a-tag>
            </div>
          </div>
          <div v-else>
            <div v-if="list.length > 7" style="margin-top: -3px;">
              <span v-for="(type, index) in list" :key="index">
                <a-tag color="#71283e" v-if="index < 5" style="margin-top: 4px">
                  {{ type.buildingUse }}
                </a-tag>
              </span>
              <a-popover title="Building Uses" trigger="hover">
                <template slot="content">
                  <div style="max-height: 300px; overflow-y: auto;">
                    <div class="pb-1" v-for="(type, i) in list" :key="i">
                      <a-tag color="#71283e">{{ type.buildingUse }}</a-tag>
                    </div>
                  </div>
                </template>
                <a-tag color="transparent" class="more-tag">
                  + {{ list.length - 5 }} More
                </a-tag>
              </a-popover>
            </div>
            <div v-else style="margin-top: -3px;">
              <a-tag v-for="(type, i) in list" :key="i" color="#71283e" style="margin-top: 4px">
                {{ type.buildingUse }}
              </a-tag>
            </div>
          </div>
        </div>
      `,
  data: function() {
    return {
      list: [],
      name: undefined,
    }
  },
  beforeMount() {
    this.name = this.params.colDef.cellRendererParams.name
    this.list = _.get(this.params, 'value', [])
    if (this.name === 'template' || this.name === 'tenantBank') {
      this.list = this.list.filter(i => i !== null)
    }
  },
})
